import cybercrimeFA from './fa/fa.json'

const CybercrimeMessages = {
  fa: { ...cybercrimeFA },
}

export default CybercrimeMessages
